const longDateOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour12: true,
    hour: '2-digit',
    minute: '2-digit'
};


const shortDateOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
};

const _formatDate = (dateStr, options) => {
    // workaround for safari and mobile browsers
    const dateParts = dateStr.split(' ');
    const fixedDate = dateParts[0].replace(/-/g, '/');
    const fullDate = [fixedDate, dateParts[1]].join(' ');
    return new Date(fullDate).toLocaleDateString('es-MX', options);
};

export const useFormatNow = () => () => new Date().toLocaleDateString('es-MX', longDateOptions);

export const useFormatDate = () => (dateStr) => _formatDate(dateStr, shortDateOptions);

export const useFormatDateTime = () => (dateStr) => _formatDate(dateStr, longDateOptions);